import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/servicios',
    name: 'Servicios',
    component:()=>import('../views/ServicesView.vue')
  },
  {
    path: '/contacto',
    name: 'Contacto',
    component:()=>import('../views/ContactView.vue')
  },
  {
    path: '/portafolio',
    name: 'Portafolio',
    component:()=>import('../views/PortfolioView.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
